module.exports = __webpack_public_path__ + "img/homesol_4.b161bbe9.png";